module.exports = __webpack_public_path__ + "img/DAmcorp_background-1.cf82e36d.jpg";